export enum LEAVE_REASON {
  EXIT,
  CHANGE_ROUTE,
  LEAVE_PAGE,
}
